// eslint-disable-next-line no-restricted-syntax
export enum BookingErrorCode {
	CarsCarTypeOnRequest = 'cars - car_type_on_request',
	CarsLocationWorkingHours = 'cars - location_working_hours',
	CarsIncorrectName = 'cars - incorrect_name',
	CarsWrongNumberCardLoyaltyCard = 'cars - wrong_number_card_loyalty_card',
}

export interface ErrorMessages {
	dev_message: string
	error_code: BookingErrorCode
	message: string
	reason: string
}

// eslint-disable-next-line no-restricted-syntax
export enum ApiBookingErrorReason {
	FareNotAvailable = 'fare_not_available',
	InvalidName = 'invalid_name',
	CreditCardIssue = 'credit_card_issue',
	UnknownError = 'unknown_error',
	ThirdPartyConnectionError = 'third_party_connection_error',
	PassportDataRequiredError = 'passport_data_required_error',
	CompletionFailed3DS = 'three_ds_verification_incomplete',
	HoldProductFeeFailed = 'payment_hold_failed',
}

export interface ErrorsInBooking extends ErrorMessages {
	user_error: string
	booking_segment_id: number
	error_type: ApiBookingErrorReason | null
}
